import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Auth
export const fetchMe = () => api.get("/auth/me").then((r) => r.data);
export const postSession = (session_id) =>
  api.post("/auth/session", { session_id }).then((r) => r.data);
export const demoLogin = (role) =>
  api.post("/auth/demo-login", { role }).then((r) => r.data);
export const passwordLogin = (email, password) =>
  api.post("/auth/password-login", { email, password }).then((r) => r.data);
export const adminCreateUser = (data) =>
  api.post("/admin/users", data).then((r) => r.data);
export const logout = () => api.post("/auth/logout").then((r) => r.data);

// Users
export const listUsers = (include_inactive = false) =>
  api.get("/users", { params: { include_inactive } }).then((r) => r.data);
export const updateUserRole = (user_id, role, client_id) =>
  api
    .patch(`/users/${user_id}/role`, { role, client_id })
    .then((r) => r.data);
export const setUserActive = (user_id, active) =>
  api.patch(`/users/${user_id}/active`, { active }).then((r) => r.data);

// Clients
export const listClients = () => api.get("/clients").then((r) => r.data);
export const createClient = (data) =>
  api.post("/clients", data).then((r) => r.data);
export const getClient = (id) => api.get(`/clients/${id}`).then((r) => r.data);

// Sites
export const listSites = (client_id) =>
  api
    .get("/sites", { params: client_id ? { client_id } : {} })
    .then((r) => r.data);
export const createSite = (data) =>
  api.post("/sites", data).then((r) => r.data);
export const updateSite = (id, data) =>
  api.patch(`/sites/${id}`, data).then((r) => r.data);

// Assets
export const listAssets = (params = {}) =>
  api.get("/assets", { params }).then((r) => r.data);
export const createAsset = (data) =>
  api.post("/assets", data).then((r) => r.data);
export const updateAsset = (id, data) =>
  api.patch(`/assets/${id}`, data).then((r) => r.data);
export const getAsset = (id) => api.get(`/assets/${id}`).then((r) => r.data);

// Work Orders
export const listWorkOrders = (params = {}) =>
  api.get("/work-orders", { params }).then((r) => r.data);
export const createWorkOrder = (data) =>
  api.post("/work-orders", data).then((r) => r.data);
export const getWorkOrder = (id) =>
  api.get(`/work-orders/${id}`).then((r) => r.data);
export const updateWorkOrder = (id, data) =>
  api.patch(`/work-orders/${id}`, data).then((r) => r.data);
export const exportWorkOrdersCsvUrl = () =>
  `${API}/export/work-orders.csv`;

// Maintenance Plans
export const listPlans = (include_inactive = false) =>
  api.get("/maintenance-plans", { params: { include_inactive } }).then((r) => r.data);
export const createPlan = (data) =>
  api.post("/maintenance-plans", data).then((r) => r.data);
export const updatePlan = (id, data) =>
  api.patch(`/maintenance-plans/${id}`, data).then((r) => r.data);
export const runPlan = (id) =>
  api.post(`/maintenance-plans/${id}/run`).then((r) => r.data);

// Dashboard
export const fetchKpis = () =>
  api.get("/dashboard/kpis").then((r) => r.data);

// AI
export const aiTriage = (payload) =>
  api.post("/ai/triage", payload).then((r) => r.data);
export const aiSummarize = (work_order_id) =>
  api.post("/ai/summarize", { work_order_id }).then((r) => r.data);

// Settings
export const getSettings = () => api.get("/settings").then((r) => r.data);
export const updateSettings = (data) =>
  api.patch("/settings", data).then((r) => r.data);

// Parts
export const listParts = (q) =>
  api.get("/parts", { params: q ? { q } : {} }).then((r) => r.data);
export const createPart = (data) =>
  api.post("/parts", data).then((r) => r.data);
export const updatePart = (id, data) =>
  api.patch(`/parts/${id}`, data).then((r) => r.data);
export const addPartToWO = (wo_id, part_id, quantity) =>
  api
    .post(`/work-orders/${wo_id}/parts`, { part_id, quantity })
    .then((r) => r.data);

// Schedule
export const fetchSchedule = (start, end) =>
  api.get("/schedule", { params: { start, end } }).then((r) => r.data);

// Upload
export const uploadFile = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api
    .post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } })
    .then((r) => r.data);
};

// Audit Log
export const listAuditLog = (params = {}) =>
  api.get("/audit-log", { params }).then((r) => r.data);
export const auditLogCsvUrl = () => `${API}/export/audit-log.csv`;

// Photo groups
export const generateGroupCaption = (wo_id, group) =>
  api
    .post(`/work-orders/${wo_id}/groups/caption`, { group })
    .then((r) => r.data);
export const renameGroup = (wo_id, old_name, new_name) =>
  api
    .patch(`/work-orders/${wo_id}/groups/rename`, { old_name, new_name })
    .then((r) => r.data);
export const deleteGroup = (wo_id, group) =>
  api
    .delete(`/work-orders/${wo_id}/groups/${encodeURIComponent(group)}`)
    .then((r) => r.data);

// Work order PDF + DOCX + Reschedule
export const workOrderPdfUrl = (wo_id) => `${API}/work-orders/${wo_id}/pdf`;
export const workOrderDocxUrl = (wo_id) => `${API}/work-orders/${wo_id}/docx`;
export const rescheduleWorkOrder = (wo_id, scheduled_for, due_date) =>
  api
    .post(`/work-orders/${wo_id}/reschedule`, { scheduled_for, due_date })
    .then((r) => r.data);

// Public Service Request (no auth)
export const publicListClients = () =>
  api.get("/public/clients").then((r) => r.data);
export const publicSubmitRequest = (payload) =>
  api.post("/public/request", payload).then((r) => r.data);
